import { mutator } from 'satcheljs';
import {
    updateSelectedOption,
    updateTextFieldValue,
    updateNavIndex,
} from '../actions/selectedOptionActions';

mutator(updateSelectedOption, actionMessage => {
    const { viewState, selectedOption } = actionMessage;

    viewState.selectedOption = selectedOption;
});

mutator(updateTextFieldValue, actionMessage => {
    const { viewState, textFieldValue } = actionMessage;

    viewState.textFieldValue = textFieldValue;
});

mutator(updateNavIndex, actionMessage => {
    const { viewState, navIndex } = actionMessage;

    viewState.navIndex = navIndex;
});
